import * as React from 'react';

import ListProductionGroups from '../../components/list/production-groups';
import ListPackages from '../../components/list/packages';

import { ListContainerProps } from '../../components/list/container';
import SpecialFeatureListView from './special-features-list.view';

const ListPerformanceGroupsContainerView: React.StatelessComponent<ListContainerProps> = props => {


    return (
        <div className="stack-sm">
            
            {
                props.isFixed ?
                    <ListPackages />
                    :
                    <ListProductionGroups />

            }

            <SpecialFeatureListView />
        </div>
    );
}

export default ListPerformanceGroupsContainerView;